module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogVisible,
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "qrCodeClass"
  }, [_c('div', {
    staticClass: "tc pr"
  }, [_c('vue-qr', {
    attrs: {
      "logoSrc": _vm.imageUrl,
      "text": _vm.codeUrl,
      "size": 200
    }
  }), _vm._v(" "), (_vm.showCodeTip) ? _c('div', {
    staticClass: "pa showCodeTip"
  }, [_c('p', {
    staticClass: "qrcodeTip mb10 mt50"
  }, [_vm._v("二维码已失效")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.refreshCode()
      }
    }
  }, [_vm._v("刷新二维码")])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tc mt20"
  }, [_vm._v("APP扫描二维码以完成人脸识别")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "exam-content m0 cb pr mt15"
  }, [_c('article', {
    staticClass: "fl exam-left"
  }, [_c('h3', {
    staticClass: "tc h3"
  }, [_vm._v(_vm._s(_vm.examPaperList.name))]), _vm._v(" "), _c('div', {
    staticClass: "exam-nav"
  }, [_c('ul', {
    staticClass: "m0"
  }, [(_vm.questionList1.length > 0) ? _c('li', {
    staticClass: "first"
  }, [_c('a', {
    class: {
      active: _vm.type == '001001'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001001');
      }
    }
  }, [_vm._v("单选题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList2.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001002'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001002');
      }
    }
  }, [_vm._v("多选题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList3.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001003'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001003');
      }
    }
  }, [_vm._v("判断题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList4.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001004'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001004');
      }
    }
  }, [_vm._v("填空题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList5.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001005'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001005');
      }
    }
  }, [_vm._v("简答题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList6.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001006'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001006');
      }
    }
  }, [_vm._v("案例题")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "examOverscroll fl"
  }, [_c('div', {
    staticClass: "option-question m0 active"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001001'),
      expression: "type == '001001'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription['001001']))]), _vm._v(" "), _vm._l((_vm.questionList1), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }), _vm._v(" "), _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-list-radio ml40 cb"
      }, [_c('div', {
        staticClass: "oh"
      }, [_c('el-radio', {
        attrs: {
          "label": choicesItem.code
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_c('span', [_vm._v(_vm._s(choicesItem.code))])]), _vm._v(" "), _c('div', {
        staticClass: "oh fl",
        staticStyle: {
          "margin-top": "5px"
        }
      }, [_c('span', {
        staticClass: "exam-words fl",
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])], 1)])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001002'),
      expression: "type == '001002'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription['001002']))]), _vm._v(" "), _vm._l((_vm.questionList2), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "option-list-radio ml40 cb"
    }, [_c('el-checkbox-group', {
      on: {
        "change": _vm.handleCheckedCitiesChange
      },
      model: {
        value: (questionsItem.userAnswer),
        callback: function($$v) {
          _vm.$set(questionsItem, "userAnswer", $$v)
        },
        expression: "questionsItem.userAnswer"
      }
    }, _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('div', {
        key: index,
        staticClass: "oh"
      }, [_c('el-checkbox', {
        attrs: {
          "label": choicesItem.code
        }
      }, [_c('span', {
        staticClass: "mr10"
      }, [_vm._v(_vm._s(choicesItem.code))])]), _vm._v(" "), _c('div', {
        staticClass: "oh fl",
        staticStyle: {
          "margin-top": "5px"
        }
      }, [_c('span', {
        staticClass: "exam-words fl",
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])], 1)
    }), 0)], 1)])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001003'),
      expression: "type == '001003'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription['001003']))]), _vm._v(" "), _vm._l((_vm.questionList3), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }), _vm._v(" "), _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-list-radio ml40 cb"
      }, [_c('div', {
        staticClass: "oh"
      }, [_c('el-radio', {
        attrs: {
          "label": choicesItem.code
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_vm._v("\n                                        " + _vm._s(choicesItem.code) + "\n                                    ")]), _vm._v(" "), _c('span', {
        staticClass: "exam-words fl mt5",
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })], 1)])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001004'),
      expression: "type == '001004'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription['001004']))]), _vm._v(" "), _vm._l((_vm.questionList4), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div option-div-tk"
    }, [_c('div', {
      staticClass: "question-box"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    })]), _vm._v(" "), _c('p', _vm._l((questionsItem.blanksNumbers), function(blanksNumbersItem, index) {
      return _c('el-input', {
        key: index,
        staticClass: "mt30 mb10 ml10",
        attrs: {
          "type": "text",
          "label": blanksNumbersItem.code
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      })
    }), 1)])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001005'),
      expression: "type == '001005'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription['001005']))]), _vm._v(" "), _vm._l((_vm.questionList5), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('div', {
      staticClass: "question-box"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "textarea"
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (questionsItem.userAnswer),
        callback: function($$v) {
          _vm.$set(questionsItem, "userAnswer", $$v)
        },
        expression: "questionsItem.userAnswer"
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001006'),
      expression: "type == '001006'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription['001006']))]), _vm._v(" "), _vm._l((_vm.questionList6), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('div', {
      staticClass: "question-box"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "textarea"
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (questionsItem.userAnswer),
        callback: function($$v) {
          _vm.$set(questionsItem, "userAnswer", $$v)
        },
        expression: "questionsItem.userAnswer"
      }
    })], 1)])
  })], 2)])])]), _vm._v(" "), _c('article', {
    staticClass: "fr exam-right"
  }, [_c('div', {
    staticClass: "exam-right-box"
  }, [_c('div', {
    staticClass: "exam-txbox mt15 fl"
  }, [_c('span', {
    staticClass: "pr fl"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "block",
      "border-radius": "50px"
    },
    attrs: {
      "src": _vm.userHeadImagUrl,
      "alt": "",
      "width": "53",
      "height": "53"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_c('span', [_vm._v("-" + _vm._s(_vm.realName) + ",上午好")]), _vm._v(" "), _c('span', {
    staticClass: "fl"
  }, [_vm._v("总分 :")]), _vm._v(" "), _c('span', {
    staticClass: "fl score"
  }, [_vm._v("  " + _vm._s(_vm.examPaperList.totalScore) + "分")])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "count-down"
  }, [_c('b', [_vm._v("倒计时")]), _vm._v(" "), _c('div', {
    staticClass: "count-down-time"
  }, [_c('count-down', {
    attrs: {
      "currentTime": _vm.currentTime,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime,
      "hourTxt": '时',
      "minutesTxt": '分',
      "secondsTxt": '秒'
    },
    on: {
      "end_callback": function($event) {
        return _vm.perconCommit()
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "prompt f14 tc"
  }, [_vm._v("考试时间为" + _vm._s(_vm.examPaperList.duration) + "分钟，请把握时间")])]), _vm._v(" "), _c('div', {
    staticClass: "selection-card"
  }, [_c('div', {
    staticClass: "exam-nav mb20"
  }, [_c('ul', {
    staticClass: "m0"
  }, [(_vm.questionList1.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001001'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001001');
      }
    }
  }, [_vm._v("单选题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList2.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001002'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001002');
      }
    }
  }, [_vm._v("多选题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList3.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001003'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001003');
      }
    }
  }, [_vm._v("判断题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList4.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001004'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001004');
      }
    }
  }, [_vm._v("填空题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList5.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001005'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001005');
      }
    }
  }, [_vm._v("简答题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList6.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001006'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001006');
      }
    }
  }, [_vm._v("案例题")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "optionsBox oh"
  }, [(_vm.questionList1.length > 0) ? _c('div', {
    staticClass: "option-block m0"
  }, _vm._l((_vm.questionList1), function(questionsItem, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == '001001'),
        expression: "type == '001001'"
      }],
      staticClass: "tc",
      class: {
        unanswered: !questionsItem.userAnswer
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.questionList2.length > 0) ? _c('div', {
    staticClass: "option-block m0"
  }, _vm._l((_vm.questionList2), function(questionsItem, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == '001002'),
        expression: "type == '001002'"
      }],
      staticClass: "tc",
      class: {
        unanswered: questionsItem.userAnswer.length == 0
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.questionList3.length > 0) ? _c('div', {
    staticClass: "option-block m0"
  }, _vm._l((_vm.questionList3), function(questionsItem, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == '001003'),
        expression: "type == '001003'"
      }],
      staticClass: "tc",
      class: {
        unanswered: !questionsItem.userAnswer
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.questionList4.length > 0) ? _c('div', {
    staticClass: "option-block m0"
  }, _vm._l((_vm.questionList4), function(questionsItem, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == '001004'),
        expression: "type == '001004'"
      }],
      staticClass: "tc",
      class: {
        unanswered: !questionsItem.userAnswer
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.questionList5.length > 0) ? _c('div', {
    staticClass: "option-block m0"
  }, _vm._l((_vm.questionList5), function(questionsItem, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.types == '001005'),
        expression: "types == '001005'"
      }],
      staticClass: "tc",
      class: {
        unanswered: !questionsItem.userAnswer
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.questionList6.length > 0) ? _c('div', {
    staticClass: "option-block m0"
  }, _vm._l((_vm.questionList6), function(questionsItem, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == '001006'),
        expression: "type == '001006'"
      }],
      staticClass: "tc",
      class: {
        unanswered: !questionsItem.userAnswer
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "push-button cb tc",
    on: {
      "click": function($event) {
        return _vm.submitExam()
      }
    }
  }, [_vm._v("我要交卷")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-bj cb"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": "/static/images/tx-vip_03.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-title fr"
  }, [_c('p', [_c('span', {
    staticClass: "f12"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/dt-bj.png",
      "alt": "",
      "height": "25"
    }
  }), _vm._v("\n            未答\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "f12"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/dt-bj3.png",
      "alt": "",
      "height": "25"
    }
  }), _vm._v("\n            已答\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0064cc81"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/ExamPaper.vue
// module id = 1124
// module chunks = 41